import React, { useState, useEffect } from "react";

const API = "https://canada-billing.ameontech.com";

export default function Security() {
  const [lastChanged, setLastChanged]     = useState(null);
  const [showModal, setShowModal]         = useState(false);
  const [currentPwd, setCurrentPwd]       = useState("");
  const [newPwd, setNewPwd]               = useState("");
  const [confirmPwd, setConfirmPwd]       = useState("");
  const [saving, setSaving]               = useState(false);
  const [msg, setMsg]                     = useState(null); // { type: "success"|"error", text }

  const token   = localStorage.getItem("token");
  const headers = { Authorization: `Bearer ${token}` };

  // ── Load last_password_changed from DB ──
  useEffect(() => {
    const fetchUser = async () => {
      try {
        const res  = await fetch(`${API}/api/user/me`, { headers });
        const data = await res.json();
        setLastChanged(data.user?.last_password_changed || null);
      } catch (err) {
        console.error("Failed to load user:", err);
      }
    };
    fetchUser();
  }, []);

  const formatDate = (iso) => {
    if (!iso) return "never";
    return new Date(iso).toLocaleDateString("en-CA", {
      year: "numeric", month: "short", day: "numeric"
    });
  };

  const handleChangePassword = async () => {
    setMsg(null);
    if (!currentPwd || !newPwd || !confirmPwd)
      return setMsg({ type: "error", text: "All fields are required." });
    if (newPwd.length < 8)
      return setMsg({ type: "error", text: "New password must be at least 8 characters." });
    if (newPwd !== confirmPwd)
      return setMsg({ type: "error", text: "New passwords do not match." });

    setSaving(true);
    try {
      const res  = await fetch(`${API}/api/user/change-password`, {
        method: "PUT",
        headers: { ...headers, "Content-Type": "application/json" },
        body: JSON.stringify({ current_password: currentPwd, new_password: newPwd }),
      });
      const data = await res.json();
      if (!res.ok) return setMsg({ type: "error", text: data.message });
      setMsg({ type: "success", text: "Password changed successfully!" });
      setLastChanged(new Date().toISOString());
      setCurrentPwd(""); setNewPwd(""); setConfirmPwd("");
      setTimeout(() => { setShowModal(false); setMsg(null); }, 1500);
    } catch (err) {
      setMsg({ type: "error", text: "Something went wrong. Try again." });
    } finally {
      setSaving(false);
    }
  };

  const closeModal = () => {
    setShowModal(false);
    setCurrentPwd(""); setNewPwd(""); setConfirmPwd("");
    setMsg(null);
  };

  return (
    <>
      <div className="st-card-hdr">
        <div className="st-card-hdr-icon" style={{ background: "rgba(249,123,107,.1)" }}>🔒</div>
        <div>
          <div className="st-card-hdr-title">Security</div>
          <div className="st-card-hdr-sub">Password and account security settings</div>
        </div>
      </div>
      <div className="st-card-body">

        {/* ── Change Password ── */}
        <div className="st-row">
          <div>
            <div className="st-row-label">Password</div>
            <div className="st-row-sub">Last changed: {formatDate(lastChanged)}</div>
          </div>
          <button className="st-avatar-btn" onClick={() => setShowModal(true)}>
            Change Password
          </button>
        </div>



      </div>

      {/* ── Change Password Modal ── */}
      {showModal && (
        <div style={{
          position: "fixed", inset: 0, background: "rgba(0,0,0,0.4)",
          display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000
        }}>
          <div style={{
            background: "#fff", borderRadius: 12, padding: 32,
            width: "100%", maxWidth: 420, boxShadow: "0 8px 32px rgba(0,0,0,0.18)"
          }}>
            <div style={{ fontWeight: 700, fontSize: 18, marginBottom: 4 }}>Change Password</div>
            <div style={{ color: "#718096", fontSize: 13, marginBottom: 24 }}>
              Enter your current password and choose a new one.
            </div>

            <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
              <div>
                <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 4 }}>Current Password</div>
                <input
                  className="st-input"
                  type="password"
                  placeholder="Enter current password"
                  value={currentPwd}
                  onChange={e => setCurrentPwd(e.target.value)}
                  style={{ width: "100%" }}
                />
              </div>
              <div>
                <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 4 }}>New Password</div>
                <input
                  className="st-input"
                  type="password"
                  placeholder="Min. 8 characters"
                  value={newPwd}
                  onChange={e => setNewPwd(e.target.value)}
                  style={{ width: "100%" }}
                />
              </div>
              <div>
                <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 4 }}>Confirm New Password</div>
                <input
                  className="st-input"
                  type="password"
                  placeholder="Re-enter new password"
                  value={confirmPwd}
                  onChange={e => setConfirmPwd(e.target.value)}
                  style={{ width: "100%" }}
                />
              </div>
            </div>

            {/* Message */}
            {msg && (
              <div style={{
                marginTop: 14, padding: "10px 14px", borderRadius: 8, fontSize: 13,
                background: msg.type === "success" ? "#f0fff4" : "#fff5f5",
                color: msg.type === "success" ? "#276749" : "#c53030",
                border: `1px solid ${msg.type === "success" ? "#9ae6b4" : "#feb2b2"}`
              }}>
                {msg.text}
              </div>
            )}

            {/* Buttons */}
            <div style={{ display: "flex", gap: 10, marginTop: 24, justifyContent: "flex-end" }}>
              <button className="st-avatar-btn" onClick={closeModal} disabled={saving}>
                Cancel
              </button>
              <button
                onClick={handleChangePassword}
                disabled={saving}
                style={{
                  padding: "8px 20px", borderRadius: 8, border: "none",
                  background: saving ? "#a0aec0" : "#4f8ef7",
                  color: "#fff", fontWeight: 600, cursor: saving ? "not-allowed" : "pointer",
                  fontSize: 14
                }}
              >
                {saving ? "Saving..." : "Update Password"}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}